module.exports = __webpack_public_path__ + "img/clock-face.dc308a3f.png";